export const NEW_GAME = 'NEW_GAME';
export const ADD_CLICKED = 'ADD_CLICKED';
export const CHECK_SET = 'CHECK_SET';
export const SHUFFLE = 'SHUFFLE';

export const newGame = () => {
  return {
    type: NEW_GAME
  }
}

export const shuffle = () => {
  return {
    type: SHUFFLE
  }
}

export const addClicked = (number, color, shape, shading, index) => {
  const action = {
    type: ADD_CLICKED,
    number,
    color,
    shape,
    shading,
    index,
  }
  return action;
}

export const checkSet = (player) => {
  return {
    type: CHECK_SET,
    player,
  }
}
